import { CustomerContactForm, CustomerSortKey, CustomersRepository } from "@/repositories/client.repository";

export async function listClients(page: number, pageSize: number, name?: string, sortKey: CustomerSortKey = "name", sortOrder: "asc" | "desc" = "asc") {
  return CustomersRepository.listByCurrentOrg(page, pageSize, name, sortKey, sortOrder);
}

export async function getClientById(id: string) {
  return CustomersRepository.getById(id);
}

export async function updateContact(id: string, contact: CustomerContactForm) {
  return CustomersRepository.updateContact(id, contact);
}

export async function inviteClient(organizationEmail: string) {
  return CustomersRepository.inviteClient(organizationEmail);
}
